import { useEffect } from 'modules/core/hooks/useEffect'
import { useRef } from 'react'

interface UsePollingOptions {
  /** Whether polling is enabled */
  enabled: boolean
  /** Callback to execute on each poll tick */
  callback: () => void
  /** Polling interval in milliseconds */
  intervalMs: number
}

/**
 * A hook that executes a callback at a regular interval when enabled.
 * Automatically stops when enabled becomes false and cleans up on unmount.
 */
export const usePolling = ({ enabled, callback, intervalMs }: UsePollingOptions) => {
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  useEffect(() => {
    if (!enabled) return

    const interval = setInterval(() => {
      callbackRef.current()
    }, intervalMs)

    return () => clearInterval(interval)
  }, [enabled, intervalMs])
}
